import React, { useEffect, useMemo, useState } from "react";
import styles from "../../styles/pages/about/Welcome3D.module.scss";

function cx(...a) { return a.filter(Boolean).join(" "); }

export default function Welcome3D({
  height = "48vh",
  maxWidth = "960px",
  rotate = true,
  intervalMs = 3000,
  words,
  ariaLabel = "Welcome in English, French and Arabic",
  className = "",
  compact = true
}) {
  const items = useMemo(
    () => (words && words.length
      ? words
      : [
          { text: "Welcome",   lang: "en", dir: "ltr" },
          { text: "Bienvenue", lang: "fr", dir: "ltr" },
          { text: "مرحبا",     lang: "ar", dir: "rtl", ar: true },
        ]),
    [words]
  );

  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!rotate || items.length <= 1) return;
    const id = setInterval(() => setIdx(i => (i + 1) % items.length), intervalMs);
    return () => clearInterval(id);
  }, [rotate, intervalMs, items.length]);

  return (
    <section
      className={cx(styles.hero, compact && styles.compact, className)}
      style={{ minHeight: height, maxWidth }}   // centered via CSS, height controlled here
      aria-label={ariaLabel}
    >
      <div className={styles.fxGrid} aria-hidden="true" />

      <div className={cx(styles.words, rotate ? styles.rotate : styles.stack)}>
        {items.map((w, i) => (
          <span
            key={`${w.text}-${i}`}
            className={cx(styles.word, w.ar && styles.ar, rotate && i === idx && styles.active)}
            lang={w.lang}
            dir={w.dir}
          >
            {w.text}
          </span>
        ))}
      </div>
    </section>
  );
}















// import React, { useEffect, useMemo, useState } from "react";
// import styles from "./Welcome3D.module.scss"; // <-- CSS Module (note: `styles`)

// function cx(...a) {
//   return a.filter(Boolean).join(" ");
// }

// export default function Welcome3D({
//   height = "72vh",
//   rotate = true,
//   intervalMs = 3000,
//   words,
//   ariaLabel = "Welcome in English, French and Arabic",
//   className = "",
// }) {
//   const items = useMemo(
//     () =>
//       (words && words.length
//         ? words
//         : [
//             { text: "Welcome", lang: "en", dir: "ltr" },
//             { text: "Bienvenue", lang: "fr", dir: "ltr" },
//             { text: "مرحبا", lang: "ar", dir: "rtl", ar: true },
//           ]),
//     [words]
//   );

//   const [idx, setIdx] = useState(0);

//   useEffect(() => {
//     if (!rotate || items.length <= 1) return;
//     const id = setInterval(() => setIdx((i) => (i + 1) % items.length), intervalMs);
//     return () => clearInterval(id);
//   }, [rotate, intervalMs, items.length]);

//   return (
//     <section
//       className={cx(styles.hero, className)}
//       style={{ minHeight: height }}
//       aria-label={ariaLabel}
//     >
//       <div className={styles.fxGrid} aria-hidden="true" />

//       <div className={cx(styles.words, rotate ? styles.rotate : styles.stack)}>
//         {items.map((w, i) => (
//           <span
//             key={`${w.text}-${i}`}
//             className={cx(styles.word, w.ar && styles.ar, rotate && i === idx && styles.active)}
//             lang={w.lang}
//             dir={w.dir}
//           >
//             {w.text}
//           </span>
//         ))}
//       </div>

//       <p className={styles.langs}>English • Français • العربية</p>
//     </section>
//   );
// }
